module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-checkbox-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-346bec50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-easytable/libs/v-checkbox-group/src/checkbox-group.vue
// module id = 1691
// module chunks = 2